import { Typography, Link } from '@mui/material';
import { styled } from '@mui/material/styles';
import { colors } from '../theme/tokens';

const FooterRoot = styled('footer')(({ theme }) => ({
  padding: theme.spacing(3),
  textAlign: 'center' as const,
  borderTop: `1px solid ${colors.border.footer}`,
}));

const Footer = () => (
  <FooterRoot>
    <Typography sx={{ fontSize: '0.8rem', color: colors.primary.main }}>
      &copy;{' '}
      <Link
        href="https://www.aidash.com"
        target="_blank"
        rel="noopener noreferrer"
        sx={{ color: colors.primary.main, textDecoration: 'underline' }}
      >
        AiDash Inc
      </Link>{' '}
      2026. All Rights Reserved
    </Typography>
  </FooterRoot>
);

export default Footer;
